import { DiscountAction, DiscountStatus } from 'interfaces';

type DiscountActionConfig = {
  i18nKey: string;
  testId: string;
};

export const DISCOUNT_ACTION_MAP: Record<DiscountAction, DiscountActionConfig> =
  {
    [DiscountAction.IN_PROGRESS]: {
      i18nKey: 'archives.action.inProgress',
      testId: 'in-progress-button',
    },
    [DiscountAction.NOT_EXTENDED]: {
      i18nKey: 'archives.action.notExtended',
      testId: 'not-extended-button',
    },
    [DiscountAction.RESTORE]: {
      i18nKey: 'archives.action.restore',
      testId: 'restore-button',
    },
    [DiscountAction.DELETE]: {
      i18nKey: 'archives.action.delete',
      testId: 'delete-button',
    },
  };

export const DISCOUNT_STATUS_ACTIONS_MAP: Partial<
  Record<DiscountStatus, DiscountAction[]>
> = {
  [DiscountStatus.EXPIRED]: [DiscountAction.IN_PROGRESS, DiscountAction.DELETE],
  [DiscountStatus.IN_PROGRESS]: [
    DiscountAction.NOT_EXTENDED,
    DiscountAction.RESTORE,
    DiscountAction.DELETE,
  ],
  [DiscountStatus.NOT_EXTENDED]: [
    DiscountAction.IN_PROGRESS,
    DiscountAction.DELETE,
  ],
};

export const getAvailableDiscountActions = (
  status?: DiscountStatus | null,
): DiscountAction[] => (status && DISCOUNT_STATUS_ACTIONS_MAP[status]) || [];
